var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { getSearchCriteriaID } from '../../services/SaveSearchCriteriaService';
import { ConfigitContext } from '../ConfigitProvider';
import { Loading } from '../shared/Loading/Loading';
import { decodeBase64 } from '../../utils/base64';
import { jsx as _jsx } from "react/jsx-runtime";
var LoadSaveSearchCriteria = function () {
    var _a = useState(), getData = _a[0], setData = _a[1];
    var _b = useContext(ConfigitContext), setManufacturerProduct = _b.setManufacturerProduct, updateConfigitCriteria = _b.updateConfigitCriteria, layerConfigMasterData = _b.layerConfigMasterData, sections = _b.sections;
    var params = useParams();
    if (!params.ShareLinkGuid) {
        throw Error('Empty SaveLinkGuid');
    }
    var initializeSaveSearch = function () { return __awaiter(void 0, void 0, void 0, function () { var _params$ShareLinkGuid, configItCriteriaString, decrypt, error_1; return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, getSearchCriteriaID((_params$ShareLinkGuid = params.ShareLinkGuid) !== null && _params$ShareLinkGuid !== void 0 ? _params$ShareLinkGuid : '')];
            case 1:
                configItCriteriaString = _a.sent();
                decrypt = decodeBase64(configItCriteriaString);
                setData(JSON.parse(decrypt));
                return [3 /*break*/, 3];
            case 2:
                error_1 = _a.sent();
                console.error('Failed to decode search criteria:', error_1);
                throw new Error('Invalid search criteria data');
            case 3: return [2 /*return*/];
        }
    }); }); };
    useEffect(function () { initializeSaveSearch(); }, []);
    useEffect(function () {
        if (getData && layerConfigMasterData !== null && layerConfigMasterData !== void 0 && layerConfigMasterData.length && sections.length) {
            var configItCriteria = JSON.parse(getData);
            if (configItCriteria.manufacturerProduct.length)
                setManufacturerProduct(configItCriteria.manufacturerProduct);
            else {
                updateConfigitCriteria(configItCriteria.variableAssignments, configItCriteria.layers, configItCriteria.excludedLayerIds);
            }
        }
    }, [getData, layerConfigMasterData, !sections.length]); // !sections.length should only trigger this effect when sections is undefined and populated not everytime it changes
    return /*#__PURE__*/ _jsx("div", { className: "d-flex justify-content-center align-items-center loading-spinner-full", children: /*#__PURE__*/ _jsx(Loading, {}) });
};
export default LoadSaveSearchCriteria;
